import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/instantso.webp';
import screenshot_target from '../../../images/letterfunnel/doekeleeuwis.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Doeke Leeuwis"
      firstname="Doeke"
      companyname="instant.so"
      competition="Replo en GemPages"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/doekeleeuwis.js